//货主版本的工作台
import React, { useEffect } from 'react';
import './index.less';
import ActivityBanner from './components/activity-banner';
import ActivitySideBanner from './components/activity-side-banner';
// import GlobalSearch from './components/global-search';
import Notify from './components/notify';
import { logindexpage } from '@/log';
import ActivitySignUp from './components/activity-sign-up';
import RecommendActivity from './components/recommend-activity';
import ChangeRole from './components/change-role';
import HelpCenterSide from './components/help-center-side';
import CollectMicroJoin from './components/collect-micro-join';

function OperatePlatform() {
  useEffect(() => {
    logindexpage();
  }, []);

  return (
    <>
      <div className="operate-platform-wrap" style={{ padding: '0 24px 24px 24px' }}>
        <ActivityBanner />
        <div className="operate-platform-parent">
          <div className="operate-platform-left">
            <Notify />
            {/* <GlobalSearch /> */}
            <RecommendActivity />
            <ActivitySignUp />
          </div>
          <div className="operate-platform-right">
            <ChangeRole />
            <CollectMicroJoin />
            {/* 侧边栏引导改为：轮播，可配置 */}
            <ActivitySideBanner />
            <HelpCenterSide />
          </div>
        </div>
      </div>
    </>
  );
}
export default OperatePlatform;
